// @file Profile Vuex Store.
import { captureNonNetworkFetchError } from 'bits/error_tracker'
import { Plugin, StoreOptions } from 'vuex'
import browser from 'vuexstore/modules/browser'
import wallCollections from 'vuexstore/modules/collections'
import electronApp, { ElectronAppState } from 'vuexstore/modules/electron_app'
import confirmationDialog from 'vuexstore/modules/global_confirmation_dialog'
import globalSnackbar from 'vuexstore/modules/global_snackbar'
import plans from 'vuexstore/modules/plans'
import electronBridgeListener from 'vuexstore/plugins/electron_bridge_listener'
import logger, { shouldLog } from 'vuexstore/plugins/logger'

type UserProfileState = {
  // Modules
  electronApp?: ElectronAppState
}

const plugins: Plugin<UserProfileState>[] = [electronBridgeListener<UserProfileState>('user_profile')]

if (shouldLog) plugins.push(logger)

export const storeOptions: StoreOptions<UserProfileState> = {
  plugins,
  modules: {
    browser,
    confirmationDialog,
    electronApp,
    plans,
    wallCollections,
    globalSnackbar,
  },
  actions: {
    initializeState({ dispatch }): void {
      dispatch('plans/fetchPlans')
      dispatch('plans/fetchAdvertisedQuotas')
    },
    genericFetchError({ dispatch }, { error }) {
      captureNonNetworkFetchError(error)
      void dispatch('globalSnackbar/genericFetchError')
    },
  },
}
